import { FC, Fragment, useMemo } from 'react'
import styled from 'styled-components'

import { Skeleton, Spacer } from '@syconium/little-miss-figgy'

import { summarizeEmbroideryGroup } from '../../../../../containers/EmbroideryContainer/utils/summarizeEmbroideryGroup'
import { SneakPeeksWrapper } from '../../../../embroidery/EmbroiderySneakPeek/styles'
import { Template } from '../../../../embroidery/EmbroiderySneakPeek/Template'
import { EmbroideryGroup, toEmbroideryLine } from '../../utils'
import { DeleteIconColumn, PriceRow } from '../PriceAndDeleteButton/styles'

import { Body, Inner, Top } from './styles'

// Mirrors `EmbroideryGroupItem`: expanded outside kits, collapsed inside them.
// The body mirrors `EmbroideryGroupContent`; keep the two layouts in sync.
export const EmbroideryGroupPlaceholder: FC<{ group: EmbroideryGroup; inKit?: boolean }> = ({
  group,
  inKit,
}) => {
  const summary = useMemo(
    () => summarizeEmbroideryGroup(group.lines.map(toEmbroideryLine)),
    [group]
  )

  return (
    <Body aria-hidden $inKit={inKit} data-testid='embroidery-cart-item-placeholder'>
      <Inner $inKit={inKit}>
        <Top>
          <Summary>
            <Skeleton animated height='13px' width='96px' />
          </Summary>
          <PriceRow>
            <Skeleton animated height='18px' width='48px' />
          </PriceRow>
          <DeleteIconColumn>
            <Skeleton animated height='20px' width='20px' />
          </DeleteIconColumn>
        </Top>
        {inKit ? null : (
          <SneakPeeksWrapper style={{ marginTop: '12px' }}>
            {summary.layout === 'combined'
              ? summary.lines.map(l => <SneakPeekPlaceholder key={l.key} />)
              : summary.sections.map(s => (
                  <Fragment key={s.type}>
                    <li>
                      <Skeleton animated height='16px' width='120px' />
                    </li>
                    {s.lines.map(l => (
                      <SneakPeekPlaceholder key={l.key} />
                    ))}
                  </Fragment>
                ))}
          </SneakPeeksWrapper>
        )}
      </Inner>
    </Body>
  )
}

const SneakPeekPlaceholder: FC = () => (
  <li>
    <Template.Container>
      <Template.Header>
        <Skeleton animated />
      </Template.Header>
      <Template.Body>
        <Skeleton animated height='13px' maxWidth='140px' />
        <Spacer height={8} />
        <Skeleton animated height='13px' maxWidth='100px' />
      </Template.Body>
    </Template.Container>
  </li>
)

// Matches `ExpansionPanel.Summary` layout without the disclosure button
const Summary = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`
